import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import LocalityList_Dwk from '../dwk/name/LocalityList';
import ProjectNameComList_Dwk from '../dwk/name/ProjectNameComList';
import ProjectNameResiList_Dwk from '../dwk/name/ProjectNameResiList';

import LocalityList_Ggn from '../gurgaon/name/LocalityList';
import ProjectNameComList_Ggn from '../gurgaon/name/ProjectNameComList';
import ProjectNameResiList_Ggn from '../gurgaon/name/ProjectNameResiList';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowImageModal extends Component {
  render() {
    
    return (
      <Modal 
      className='min-max-width'
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      // basic
      >
       
        <Modal.Content>
        {this.props.locality_Dwk && <LocalityList_Dwk  closeModal={this.props.closeModal} />}
        {this.props.projCom_Dwk && <ProjectNameComList_Dwk closeModal={this.props.closeModal} />}
        {this.props.projResi_Dwk && <ProjectNameResiList_Dwk  closeModal={this.props.closeModal} />}

        {this.props.locality_Ggn && <LocalityList_Ggn  closeModal={this.props.closeModal} />}
        {this.props.projCom_Ggn && <ProjectNameComList_Ggn closeModal={this.props.closeModal} />}
        {this.props.projResi_Ggn && <ProjectNameResiList_Ggn  closeModal={this.props.closeModal} />}
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowImageModal);
